module.exports = __webpack_public_path__ + "img/tsumugi_2.e85c010b.png";